const resetPassword = () => {
  return import('@/pages/ResetPassword/ResetPassword')
}
const inputEmailToResetPassword = () => {
  return import('@/pages/ResetPassword/InputEmail')
}

export const resetPasswordRoutes = [
  // 新パスワード入力
  {
    path: '/account/password/reset',
    name: 'ResetPassword',
    component: resetPassword,
    props: route => ({ query: route.query.token }),
    meta: { requireAuth: false },
  },
  // パスワードリセット用メールアドレス入力
  {
    path: '/account/password/reset/input-email',
    name: 'inputEmailToResetPassword',
    component: inputEmailToResetPassword,
    meta: { requireAuth: false },
  },
]
